export default __webpack_public_path__ + "static/media/usa-star-1x.6390ec8b.png";